var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_129)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82ZM67 41C67 55.3594 55.3594 67 41 67C26.6406 67 15 55.3594 15 41C15 26.6406 26.6406 15 41 15C55.3594 15 67 26.6406 67 41ZM48.7317 35.4089L36.6759 46.2883L36.2333 52.9167C36.8657 52.9167 37.1547 52.6353 37.5039 52.2953C37.5137 52.2858 37.5235 52.2762 37.5333 52.2667L40.6563 49.23L47.1533 54.0301C48.349 54.6898 49.212 54.3483 49.5098 52.92L53.7749 32.8214C54.2116 31.0707 53.1075 30.2766 51.9637 30.7959L26.9192 40.453C25.2097 41.1387 25.2196 42.0924 26.6076 42.5174L33.0346 44.5233L47.9137 35.1363C48.6161 34.7103 49.2608 34.9393 48.7317 35.4089Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTelegram);
export default __webpack_public_path__ + "static/media/logoTelegram.ab1104b564d3fe46bf2525d4eefa011a.svg";
export { ForwardRef as ReactComponent };